export default __webpack_public_path__ + "static/media/purple-trash.f6ffa4f0.svg";